import { render } from "./CreateNewLookalikeAudiance.vue?vue&type=template&id=60357080&scoped=true"
import script from "./CreateNewLookalikeAudiance.vue?vue&type=script&lang=js"
export * from "./CreateNewLookalikeAudiance.vue?vue&type=script&lang=js"

import "./CreateNewLookalikeAudiance.vue?vue&type=style&index=0&id=60357080&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60357080"]])

export default __exports__